<template>
  <transition name="expandir">
    <div v-if="abierto" class="modal-backdrop" @click="close">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div class="grid-modal" @click="(e) => e.stopPropagation()">
          <div class="box-logo">
            <vue-load-image v-if="sourceLogo && beneficio && beneficio.urlLogo">
              <img
                slot="image"
                :src="sourceLogo + beneficio.urlLogo"
                alt="Logo"
              />
              <!-- Indicador de carga de imagen -->
              <div slot="preloader">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </vue-load-image>
            <!-- Indicador de carga de beneficio -->
            <div v-else class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="salir-modal">
            <button
              type="button"
              class="btn-close"
              @click="close"
              aria-label="Cerrar ventana"
            >
              <span>x</span>
            </button>
          </div>
          <template v-if="beneficio">
            <div class="comercio">
              <h2 v-if="beneficio.comercio">{{ beneficio.comercio.nombre }}</h2>
            </div>
            <div class="dir-y-tel">
              <div>
                <i
                  class="fa fa-map-marker"
                  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.3/css/font-awesome.min.css"
                  rel="stylesheet"
                  aria-hidden="true"
                ></i>
                <h5>Dirección:</h5>
                <p v-if="beneficio.comercio && beneficio.comercio.direccion">
                  {{ beneficio.comercio.direccion }}
                </p>
              </div>
              <div>
                <i
                  class="fa fa-phone"
                  href="path/to/font-awesome/css/font-awesome.min.css"
                  rel="stylesheet"
                  aria-hidden="true"
                ></i>
                <h5>Teléfono:</h5>
                <p v-if="beneficio.comercio && beneficio.comercio.telefono">
                  {{ beneficio.comercio.telefono }}
                </p>
              </div>

              <div>
                <i
                  class="fa fa-whatsapp"
                  href="path/to/font-awesome/css/font-awesome.min.css"
                  rel="stylesheet"
                  aria-hidden="true"
                ></i>
                <h5>WhatsApp:</h5>
                <p v-if="beneficio.comercio && beneficio.comercio.whatsapp">
                  {{ beneficio.comercio.whatsapp }}
                </p>
              </div>
            </div>
            <div class="descuento">
              <p
                v-bind:style="{
                  'font-size': fontSizeLabel(beneficio.porcentajeDescuento),
                  'margin-top': marginTopDescuento(
                    beneficio.porcentajeDescuento
                  ),
                }"
              >
                {{ beneficio.porcentajeDescuento }}
              </p>
            </div>
            <div class="observaciones">
              <div class="dias">
                <h3>Días</h3>
                <p>{{ beneficio.diasHabilitados | diasSemana }}</p>
              </div>
              <div>
                <hr />
              </div>
              <div class="medio-pago">
                <h3>Medios de Pago</h3>
                <p>{{ beneficio.medioPago }}</p>
              </div>
              <div>
                <hr />
              </div>
            </div>

            <div class="btn-suscrip">
              <template v-if="suscripto">Estás suscripto!</template>
              <template v-else>
                <button
                  v-if="esUsuario"
                  :disabled="suscribiendo"
                  class="btn btn-success"
                  @click="suscribir()"
                >
                  <span
                    v-if="suscribiendo"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  >
                  </span>
                  <span v-if="suscribiendo"> Suscribiendo...</span>
                  <span v-if="!suscribiendo">Suscribirme! </span>
                </button>
              </template>
            </div>

            <div class="logo-mas-beneficios">
              <img src="img/regalo-mas-beneficios.png" />
            </div>
            <div class="ver-comercio">
              <button type="button" class="btn btn-link" @click="verComercio()">
                <font-awesome-icon :icon="Icons.COMERCIO" />
                Ver Comercio
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import {
  faEraser,
  faDoorClosed,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";
import VueLoadImage from "vue-load-image";

import { environment } from "../../environments/environment";
import { Icons as IconConstants } from "../../constants";
import { Vistas } from "../../routes/cliente.routes";

export default {
  name: "ModalInfoBeneficio",
  props: {
    esUsuario: Boolean,
    service: Function,
  },
  components: {
    FontAwesomeIcon,
    VueLoadImage,
  },
  data() {
    return {
      abierto: false,
      beneficio: {},
      // Id del beneficio abierto
      idBeneficio: null,
      idUsuario: "",
      usuario: {},
      suscripcion: {},
      // Indica si el usuario está suscripto al beneficio
      suscripto: null,
      sourceLogo: "",
      suscribiendo: false,
    };
  },
  computed: {
    appIcon2() {
      return faEraser;
    },
    appIcon3() {
      return faDoorClosed;
    },
    appIcon4() {
      return faHeart;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    UrlComercios() {
      return environment.URL_COMERCIOS_QR;
    },
  },
  methods: {
    abrir(idBeneficio, suscripto) {
      this.beneficio = undefined;

      this.idBeneficio = idBeneficio;
      this.suscripto = suscripto;
      this.abierto = true;

      this.service.get(this.idBeneficio).then((response) => {
        this.beneficio = response.data;
      });
    },
    close() {
      this.abierto = false;
      this.$emit("close");
    },
    suscribir() {
      this.suscribiendo = true;

      this.idUsuario = localStorage.getItem("iduser");

      axios
        .get(environment.API_URL + "cliente/" + this.idUsuario)
        .then((response) => {
          this.usuario = response.data;
          this.suscripcion.cliente = this.usuario;
          this.suscripcion.beneficio = this.beneficio;

          const promesa = axios.post(
            environment.API_URL + "sub-beneficio",
            this.suscripcion,
            {
              headers: { Authorization: "Token " + this.token },
            }
          );

          // Enviar promesa y beneficio, si este componente es cerrado,
          // La promesa seguirá activa y se puede trabajar desde afuera tranquilamente
          this.$emit("suscribiendo", {
            promesa: promesa,
            beneficio: this.beneficio,
          });

          promesa
            .then(() => {
              this.close();
              Swal.fire(
                "Confirmación",
                "Se suscribió al beneficio seleccionado",
                "success"
              );
            })
            .catch((error) => {
              Swal.fire(
                "Error",
                "Ocurrió un error al intentar suscribirse.",
                "error"
              );
              console.log(error);
            })
            .finally(() => {
              this.suscribiendo = false;
            });
        })
        .catch((error) => {
          Swal.fire(
            "Error",
            "Ocurrió un error al intentar suscribirse.",
            "error"
          );
          console.log(error);

          this.suscribiendo = false;
        });
    },
    verComercio() {
      this.$router.push(
        "/home/" + Vistas.Comercio.UrlRelativa + "/" + this.beneficio.comercio.id
      );
    },
    // Funcion para adaptar texto dentro de corazon
    fontSizeLabel(palabra) {
      const cantCar = palabra.length;
      var anchoPantalla = window.innerWidth;
      var altoPantalla = window.innerHeight;
      var newSizeFont;
      var maxFont = "34px";
      if (anchoPantalla <= 992) {
        newSizeFont = (anchoPantalla * 60) / 100 / cantCar;
        newSizeFont = newSizeFont <= 0 ? 1 : newSizeFont;
        if (altoPantalla > 450) {
          maxFont = "8vw";
        }
        return "max(min(" + newSizeFont + "px, " + maxFont + ") ,8px)";
      } else {
        newSizeFont = 390 / cantCar;
        newSizeFont = newSizeFont <= 0 ? 1 : newSizeFont;
        if (altoPantalla > 450) {
          maxFont = "58px";
        } 
        if (altoPantalla > 576) {
          maxFont = "78px";
        } 
        return "max(min(" + newSizeFont + "px, " + maxFont + ") ,8px)";
      }
    },
    marginTopDescuento(palabra) {
      const cantCar = palabra.length;
      var anchoPantalla = window.innerWidth;
      var marginTop = 390 / cantCar;
      var margen = 30 / marginTop;
      if (anchoPantalla > 991) {
        if (marginTop > 44) {
          return 0 + "rem";
        } else {
          marginTop = marginTop <= 44 ? margen : marginTop;
          return "min(" + marginTop + "rem, 2rem)";
        }
      } else {
        return "0rem";
      }
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.sourceLogo = environment.API_URL + "images/logos/";
  },
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.modal-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: var(--color-moda-h);
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  height: 90vw;
  width: 90vw;
  position: initial;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

/* Original
.grid-modal {
  display: grid;
  color: var(--color-estructura-a);
  font-family: var(--fuente-din);
  justify-items: left;
  align-items: center;
  height: 100%;
  width: 100%;
  grid-template-rows: 35px 50px 80px 130px 50px 60px 55px;
  grid-template-columns: 50% 40% 10%;
  grid-template-areas:
    "logo   nombre       salir"
    "logo   dirytel      dirytel"
    "logo   descuento    descuento"
    "logo   observa      observa"
    "logo   btn-suscrip  btn-suscrip"
    "logo   logosuma     logosuma"
    "logo   ver-comercio ver-comercio";
} */

.grid-modal {
  display: grid;
  color: var(--color-estructura-a);
  font-family: var(--fuente-din);
  justify-items: left;
  align-items: center;
  height: 100%;
  width: 100%;
  /* overflow-y: auto;
  overflow-x: hidden; */
  grid-template-rows: 0% 60% 5% 15% 15% 5%;
  grid-template-columns: 50% 50%;
  grid-template-areas:
    "   -         salir"
    "logo         logo"
    "nombre       observa"
    "descuento    observa"
    "dirytel      logosuma"
    "ver-comercio  btn-suscrip";
}

.box-logo {
  grid-area: logo;
  background: #526573;
  height: 100%;
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-logo img {
  width: 100%;
  background-image: cover;
}

.salir-modal {
  grid-area: salir;
  justify-self: right;
  position: relative;
  display: block;
  background: var(--color-estructura-a);
  border-radius: 25px;
  width: 25px;
  height: 25px;
  right: 5px;
  transform: translate(0vw, 5vw);
  -moz-transform: translate(0vw, 5vw);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.salir-modal button {
  position: absolute;
  background: transparent;
  border-radius: 25px;
  width: 25px;
  height: 25px;
  right: 0;
  cursor: pointer;
}

.salir-modal:hover {
  background: white;
}

.btn-close {
  border: none;
  font-size: 16px;
  font-weight: bold;
  padding: 0px !important;
  cursor: pointer;
  color: var(--color-estructura-c);
  background: transparent;
  bottom: 2px;

  /* -webkit-transform: translateY(5%);
  -moz-transform: translateY(-5%); */
  -webkit-transform: translateY(12%);
  -moz-transform: translateY(2px);

  right: 1%;
}

.btn-close:focus {
  outline: none;
}

.btn-close:hover {
  color: black;
}

.comercio {
  grid-area: nombre;
  margin-left: 10px;
  /* overflow: auto; */
  height: 100%;
  width: 90%;
}

.comercio h2 {
  font-size: 15px;
  margin: 3px 0 3px;
  height: max-content;
  width: max-content;
}

.dir-y-tel {
  grid-area: dirytel;
  justify-self: left;
  text-align: left;
  width: 90%;
  height: 100%;
  margin-left: 10px;
  padding-top: 5px;
  overflow-x: overlay;
  overflow-y: hidden;
  /* padding-bottom: 70px; */
  z-index: 500;
}

.dir-y-tel div {
  position: relative;
  height: 20px;
  width: 90%;
}

.dir-y-tel div i {
  position: absolute;
  color: var(--color-estructura-c);
  font-size: 13px;
}

.dir-y-tel div h5 {
  font-size: 11px;
  left: 15px;
  position: relative;
}

.dir-y-tel div p {
  font-size: 13px;
  position: absolute;
  left: 70px;
  top: -4px;
  width: max-content;
}

.descuento {
  grid-area: descuento;
  height: 100%;
  justify-self: center;
  margin-left: 10px;
  /* margin-right: 30px; */
  position: relative;
  padding-top: 7px;
}

.descuento p {
  font-size: 45px;
  position: relative;
  /* left: 20px; */
  margin-bottom: 20px;
  top: -10px;
}

.observaciones {
  grid-area: observa;
  position: relative;
  justify-self: center;
  width: 100%;
  padding-right: 20px;
  height: 100%;
  padding-left: 20px;
  overflow-y: auto;
}

.observaciones p {
  font-size: 12px;
  margin-bottom: 0;
}

.dias,
.medio-pago {
  text-align: left;
}

.observaciones div h3 {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 5px;
  margin-bottom: -3px;
  text-align: left;
  font-size: 11px;
  line-height: normal;
  font-family: var(--fuente-din-d);
}

.observaciones div hr {
  background: var(--color-estructura-a);
  height: 1px;
  top: 38%;
  position: relative;
  width: 80%;
  transform: translateX(-12%);
  margin: 0 0 0.5rem 9%;
}

.btn-suscrip {
  grid-area: btn-suscrip;
  width: 100%;
  padding-right: 10px;
  height: 100%;
  position: relative;
  justify-self: center;
  margin-left: 10px;
  bottom: 10px;
  /* padding-top: 10px; */
}

.btn-suscrip button {
  height: 100%;
  padding-bottom: 4vw;
  padding-top: 1vw;
  font-size: 2.5vw;
}

.ver-comercio {
  grid-area: ver-comercio;
  width: 100%;
}

.ver-comercio button {
  color: black;
  font-size: 2.5vw;
  text-decoration: none;
}

.ver-comercio button svg {
  /* width: 0.6em; */
  width: 2.5vw;
}

.ver-comercio button:hover {
  color: white;
}

.logo-mas-beneficios {
  grid-area: logosuma;
  width: 100%;
  margin-left: 10px;
}

.logo-mas-beneficios img {
  width: 43%;
  position: relative;
  bottom: 1vw;
}

/****************************/
a {
  color: #42b983;
}

.shadow2 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow2:hover {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

/** Animaciones modal info beneficio */
.expandir-enter-active {
  animation: expandir 1s;
}

.expandir-leave-active {
  animation: expandir 0.5s reverse;
}

@keyframes expandir {
  0% {
    transform: scale(0, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .modal {
    background: #cfb0e4;
    height: 80vw;
    width: 80vw;
  }

  .grid-modal {
    grid-template-rows: 0% 60% 6% 14% 12% 8%;
  }

  .salir-modal {
    transform: translate(0vw, 3vw);
    -moz-transform: translate(0vw, 3vw);
  }

  .comercio {
    overflow: auto;
    height: 100%;
    width: 100%;
  }

  .comercio h2 {
    font-size: 18px;
  }

  .descuento p {
    font-size: 8vw;
  }

  .dir-y-tel {
    width: 90%;
  }

  .logo-mas-beneficios {
    margin-bottom: 10px;
  }

  .logo-mas-beneficios img {
    width: 14vw;
    top: 1px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .modal {
    background: #c7c176;
    height: 70vw;
    width: 70vw;
  }

  .salir-modal {
    transform: translate(0vw, 2.5vw);
    -moz-transform: translate(0vw, 2.5vw);
  }

  .comercio h2 {
    font-size: 2.5vw;
  }

  .dir-y-tel {
    padding-bottom: 50px;
  }

  .descuento {
    padding-top: 5px;
  }

  .descuento p {
    font-size: 55px;
  }

  .dias p,
  .dias h3,
  .medio-pago p,
  .medio-pago h3 {
    font-size: 2vw !important;
  }

  .logo-mas-beneficios {
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .logo-mas-beneficios img {
    width: 110px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .modal {
    background: #76c77d;
    height: 600px;
    width: 600px;
  }

  .grid-modal {
    grid-template-rows: 0% 60% 6% 17% 9% 8%;
    grid-template-areas:
      " - salir"
      "logo logo"
      "nombre nombre"
      "descuento observa"
      "dirytel logosuma"
      "ver-comercio btn-suscrip";
  }

  .salir-modal {
    right: 10px;
    top: 10px;
    transform: translate(0vw, 12px);
    -moz-transform: translate(0vw, 12px);
  }

  .comercio {
    height: 100%;
    width: 84%;
    padding-left: 11%;
    padding-top: 3%;
    overflow: visible;
  }

  .comercio h2 {
    font-size: 22px;
    margin: 0;
  }

  .dir-y-tel {
    padding-bottom: 50px;
    height: 100%;
    padding-left: 20%;
  }

  .descuento {
    height: 100%;
    margin-bottom: 0px;
    padding-left: 20%;
    justify-self: left;
  }

  .descuento p {
    font-size: 78px;
  }

  .observaciones {
    height: 100%;
    bottom: 0;
    margin-top: 11px;
    overflow-y: auto;
    overflow-x: hidden;
    height: 112px;
  }

  /* .observaciones {
    grid-area: observa;
    display: grid;
    grid-template-columns: 45% 10% 45%;
  } */

  .observaciones p,
  .observaciones div h3 {
    font-size: 15px !important;
  }

  /* .observaciones :nth-child(2),
  .observaciones :nth-child(4){
    overflow: hidden;
  } */
  .observaciones div hr {
    height: 2px;
    transform: translateX(-9%);
    width: 111%;
  }

  .btn-suscrip {
    height: 65%;
    margin-top: 15px;
  }

  .btn-suscrip button {
    padding-bottom: 0px;
    padding-top: 3px;
    font-size: 17px;
  }

  .logo-mas-beneficios {
    width: 90%;
    margin: 12px 0px 0px 13px;
  }

  .logo-mas-beneficios img {
    width: 98px;
  }

  .ver-comercio {
    padding-left: 5%;
  }

  .ver-comercio button {
    font-size: 24px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .modal {
    background: #79b4b6;
  }
}

@media (min-width: 1200px) and (max-height: 769px) {
  .grid-modal .comercio {
    padding-top: 2%;
    overflow: visible;
    h2 {
      font-size: 2.8vh;
    }
  }
}

@media (min-width: 576px) and (max-height: 576px) {
  .modal {
    background: #cfb0e4;
    height: 90vh;
    width: 70vw;
  }

  .grid-modal {
    grid-template-rows: 0% 60% 6% 14% 12% 8%;
  }

  .salir-modal {
    transform: translate(0vw, 2vw);
    -moz-transform: translate(0vw, 2vw);
  }

  .comercio {
    overflow: auto;
    height: 100%;
    width: 100%;
  }

  .comercio h2 {
    font-size: 18px;
  }

  .descuento p {
    font-size: 10vh;
  }

  .dir-y-tel {
    width: 90%;
  }

  .dias p,
  .dias h3,
  .medio-pago h3,
  .medio-pago p {
    font-size: 2vh !important;
  }

  .logo-mas-beneficios {
    margin-bottom: 20px;
  }

  .logo-mas-beneficios img {
    width: 14vh;
    top: 1px;
  }

  .btn-suscrip button {
    padding-bottom: 3vh;
    padding-top: 1.5vh;
    font-size: 2.5vh;
  }

  .ver-comercio button {
    font-size: 2.5vh;
  }
}

@media (min-width: 769px) and (max-height: 769px) {
  .modal {
    background: #cfb0e4;
    // height: 80vh;
    // width: 80vh;
  }

  .grid-modal {
    grid-template-rows: 0% 60% 6% 14% 12% 8%;
  }

  .salir-modal {
    transform: translate(0vw, 2vw);
    -moz-transform: translate(0vw, 2vw);
  }

  .comercio {
    overflow: auto;
    height: 100%;
    width: 100%;
  }

  .comercio h2 {
    font-size: 18px;
  }

  .descuento p {
    font-size: 10vh;
  }

  .dir-y-tel {
    width: 90%;
  }

  .dias p,
  .dias h3,
  .medio-pago h3,
  .medio-pago p {
    font-size: 2vh !important;
  }

  .logo-mas-beneficios {
    margin-bottom: 20px;
  }

  .logo-mas-beneficios img {
    width: 14vh;
    top: 1px;
  }

  .btn-suscrip button {
    padding-bottom: 3vh;
    padding-top: 1.5vh;
    font-size: 2.5vh;
  }

  .ver-comercio button {
    font-size: 2.5vh;
  }
}

@media (min-width: 992px) and (max-height: 576px) {
  .btn-suscrip button {
    padding-bottom: 3vh;
    padding-top: 1.5vh;
    font-size: 2.5vh;
  }
}

@media (min-width: 992px) and (max-height: 769px) {
  .btn-suscrip button {
    padding-bottom: 0px;
    padding-top: 3px;
    font-size: 17px;
  }
}

@media (min-width: 993px) and (max-width: 1199px) and (max-height: 576px) {
  .btn-suscrip button {
    padding-bottom: 3vh;
    padding-top: 0.5vh;
    font-size: 2.5vh;
  }

  .salir-modal {
    transform: translate(0vw, 1vw);
    -moz-transform: translate(0vw, 1vw);
  }

  .comercio {
    // overflow: hidden;
    height: 100%;
    width: 100%;
    padding-top: 0;
    display: flex;
    overflow: visible;
    flex-direction: column;
    justify-content: center;
    padding-left: 10.5%;
  }

  .comercio h2 {
    font-size: 12px;
  }

  .descuento p {
    font-size: 10vh;
  }

  .dir-y-tel {
    width: 90%;
  }

  .dir-y-tel div h5,
  .dir-y-tel div p {
    font-size: 9px;
  }

  .dir-y-tel div p {
    left: 60px;
    top: -1px;
  }

  .dir-y-tel div i {
    font-size: 10px;
    top: -2px;
  }

  .dias p,
  .dias h3,
  .medio-pago h3,
  .medio-pago p {
    font-size: 2vh !important;
  }

  .logo-mas-beneficios {
    margin-bottom: 20px;
  }

  .logo-mas-beneficios img {
    width: 14vh;
    top: 1px;
  }

  .btn-suscrip {
    margin-top: 0px;
  }

  .btn-suscrip button {
    padding-bottom: 3vh;
    padding-top: 0.5vh;
    font-size: 2vh;
  }

  .ver-comercio button {
    font-size: 2.5vh;
  }
}

@media screen and (max-width: 991px) {
  .descuento {
    display: flex;
    justify-self: left !important;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    p {
      top: initial;
      margin-bottom: initial;
      left: initial;
    }
  }
}
</style>
